export const MIN_VOICE_NOTE_DURATION_MS = 750;
export const MIN_VOICE_NOTE_BYTES = 1024;

export function isVoiceNoteRecordingUsable({
  durationMs,
  sizeBytes,
}: {
  durationMs: number;
  sizeBytes: number;
}) {
  return durationMs >= MIN_VOICE_NOTE_DURATION_MS && sizeBytes >= MIN_VOICE_NOTE_BYTES;
}

export function isVoiceNoteAttachment(file: File) {
  const fileName = String(file.name || "").toLowerCase();
  const mimeType = String(file.type || "").toLowerCase();
  return mimeType.startsWith("audio/") || /\.(webm|mp3|m4a|wav|ogg)$/.test(fileName);
}
